import React from 'react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

export function neighborTensQuestion(question) {
  const spec = question?.visual_spec;
  const unit = spec?.unit ?? 10;
  if (spec?.renderer !== 'neighbor_tens' || !Number.isInteger(spec.number) || !Number.isInteger(spec.lower)
    || ![10, 100].includes(unit) || spec.lower < 0 || spec.lower % unit !== 0 || spec.upper !== spec.lower + unit
    || spec.number < spec.lower || spec.number >= spec.upper) return null;
  const answers = [String(spec.lower), String(spec.upper)];
  if (!answers.every((answer) => question.choices?.includes(answer))) return null;
  if (question.correct_answer != null && !answers.includes(String(question.correct_answer))) return null;
  return { target: spec.number, answers };
}

export default function NeighborTensAnswer({ question, selectedChoice, correctAnswer, reveal, disabled, onAnswer }) {
  return <Box data-testid="neighbor-tens-answer" sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', gap: { xs: 1, md: 2 }, p: { xs: 1, md: 2 } }}>
    {question.answers.map((answer, index) => {
      const correct = reveal && String(correctAnswer) === answer;
      const wrong = reveal && String(selectedChoice) === answer && !correct;
      return <React.Fragment key={answer}>
        {index === 1 && <Typography aria-label={`Yuvarlanacak sayı: ${question.target}`} sx={{ fontSize: { xs: 26, md: 36 }, fontWeight: 900, color: '#172554' }}>{question.target}</Typography>}
        <ButtonBase disabled={disabled} onClick={() => onAnswer(answer)} aria-label={answer}
          sx={{ position: 'relative', minWidth: { xs: 88, sm: 130, md: 145 }, minHeight: { xs: 82, md: 100 }, p: 1, borderRadius: 3,
            border: `3px solid ${correct ? '#22c55e' : wrong ? '#fb7185' : '#2563eb'}`,
            bgcolor: correct ? '#ecfdf3' : wrong ? '#fff1f2' : '#eff6ff', color: correct ? '#15803d' : '#172554',
            fontSize: { xs: 27, md: 36 }, fontWeight: 900,
            '&:hover': { bgcolor: '#dbeafe' }, '&:focus-visible': { outline: '4px solid #a78bfa', outlineOffset: 3 } }}>
          {correct && <CheckCircleRoundedIcon aria-label="Doğru cevap" sx={{ position: 'absolute', top: 4, left: 4, fontSize: { xs: 20, md: 24 }, color: '#16a34a' }} />}
          {answer}
        </ButtonBase>
      </React.Fragment>;
    })}
  </Box>;
}
